import React from 'react'
import { useTranslation } from 'react-i18next'
import Text from '../../../../../../elements/Typo/Text'

interface StatCardProps {
    title: string
    value: string | number
    txtTitleColor?: string // To style the text green
    txtValueColor?: string
    cardColor?: string
    unit?: string
    highlight?: string
}

const StatCard: React.FC<StatCardProps> = ({ title, value, txtTitleColor = '#000', txtValueColor = '#000', cardColor = '#F1F1F1', unit = '', highlight = '' }) => {
    const { t } = useTranslation()
    return (
        <div className={`col-span-2 md:col-span-1 rounded-xl  shadow-md  border bg-white relative h-fit`} style={{ background: cardColor, contain: highlight }} aria-label={t('Insight Card')}>
            <div className="w-full h-full p-3">
                <Text className={`font-poppins text-[0.542rem] leading-[19.5px] tracking-[0px]  mb-1  `} style={{ color: txtTitleColor }}>
                    {title}
                </Text>
                <p className={`text-sm font-semibold `} style={{ color: txtValueColor }}>
                    {value} {unit ? ` ${unit}` : ''}
                </p>
            </div>
        </div>
    )
}

export default StatCard
